import { formatFuelBalance } from 'core-lib/utils/fuel';
import BackButton from 'ui-v2/components/BackButton';
import { Button } from 'ui-v2/components/Button';
import Icon from 'ui-v2/components/Icon/Icon';
import Modal from 'ui-v2/components/Modal';
import { Typography } from 'ui-v2/components/Typography';
import { handleBarrelRedirection } from '../../../utils';
import s from './PetrolBalancePopup.module.scss';

type balacePropType = {
  show: boolean;
  onClose: () => void;
  balance: number;
};

export const PetrolBalancePopup = ({
  show,
  onClose,
  balance,
}: balacePropType) => {
  return (
    <Modal
      show={show}
      head={{
        show: true,
        onClose: onClose,
      }}
      rootStyle={{
        zIndex: 12,
      }}
    >
      <BackButton type="hidden" onBack={() => onClose()} />
      <div className={s.root}>
        <Typography label="Your Park+ Petrol Balance" variant="label_1_bold" />
        <div className={s.chip}>
          <Icon name="FuelDrop" width={16} height={16} />
          <Typography
            label={formatFuelBalance(balance)}
            variant="label_2_bold"
          />
        </div>
        <Typography
          label={
            balance > 0
              ? 'Use this to get additional discounts'
              : 'Earn now to get additional discounts'
          }
          variant="label_1_semi_bold"
        />
        <Typography
          label="up to 60% off on 5,000+ products"
          color="secondary"
          variant="body_3_regular"
        />
        <div className={s.button}>
          <Button
            size="medium"
            variant="primary"
            label="Back to store"
            style={{ width: '100%' }}
            onClick={onClose}
          />
          <Button
            label={balance > 0 ? 'View more details' : 'Earn Park+ Petrol'}
            size="small"
            variant={balance > 0 ? 'ghost_color' : 'secondary_color'}
            onClick={handleBarrelRedirection}
            style={{
              width: '100%',
              marginTop: '8px',
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
